import { render, staticRenderFns } from "./PrivacyHuaWei1.vue?vue&type=template&id=0b1ddb35&scoped=true"
import script from "./PrivacyHuaWei1.vue?vue&type=script&lang=js"
export * from "./PrivacyHuaWei1.vue?vue&type=script&lang=js"
import style0 from "./PrivacyHuaWei1.vue?vue&type=style&index=0&id=0b1ddb35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ddb35",
  null
  
)

export default component.exports